export const getTimerFormat = (totalSec: number) => {
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return {
    min: min < 10 ? `0${min}` : `${min}`,
    sec: sec < 10 ? `0${sec}` : `${sec}`,
  };
};
